import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort",
  "use": "sort-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"sort\">\n  <path d=\"M3 15L5.88675 10H0.113249L3 15ZM2.5 0L2.5 10.5H3.5L3.5 0L2.5 0Z\" />\n  <path d=\"M11 -9.53674e-07L8.11325 5L13.8868 5L11 -9.53674e-07ZM11.5 15L11.5 4.5L10.5 4.5L10.5 15L11.5 15Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol